export const getPropertyList = (obj, getObjName) =>
  Object.values(obj).map(value => ({ value, label: getObjName(value) }));
